import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-booking-specified-repeat-switcher"
export default class extends Controller {
  static targets = [
    'repeat',
    'repeatBookingsToggle',
    'specified',
    'specifiedBookingsToggle'
  ]

  connect() {
    this.toggle()
  }


  switchToRepeat() {
    this.specifiedTarget.classList.add('hidden')
    this.repeatTarget.classList.remove('hidden')
  }

  switchToSpecified() {
    this.repeatTarget.classList.add('hidden')
    this.specifiedTarget.classList.remove('hidden')
  }

  toggle() {
    if (this.repeatBookingsToggleTarget.checked) {
      this.switchToRepeat()
    } else if (this.specifiedBookingsToggleTarget.checked) {
      this.switchToSpecified()
    } else {
      this.specifiedTarget.classList.add('hidden')
      this.repeatTarget.classList.add('hidden')
    }
  }
}
